import Vue from 'vue';
import VueI18n from 'vue-i18n';
import {DEFAULT_LANGUAGE} from '@/shared/constants/language';
import messages from '@/lang/all';

Vue.use(VueI18n);

export let LANGUAGE_SELECTED = localStorage.getItem('x_lang');
if (!LANGUAGE_SELECTED) {
  LANGUAGE_SELECTED = DEFAULT_LANGUAGE;
}

const i18n = new VueI18n({
  locale: LANGUAGE_SELECTED,
  fallbackLocale: DEFAULT_LANGUAGE,
  messages
})

// const loadedLanguages = [LANGUAGE_SELECTED];

// function setI18nLanguage (lang) {
//   i18n.locale = lang
// //   axios.defaults.headers.common['Accept-Language'] = lang
//   document.querySelector('html').setAttribute('lang', lang)
//   return lang;
// }

// export function loadLanguageAsync (lang) {
//   if (i18n.locale !== lang) {
//     localStorage.setItem('x_lang', lang);
//     if (!loadedLanguages.includes(lang)) {
//       return import(`@/lang/${lang}`).then(msgs => {
//         i18n.setLocaleMessage(lang, msgs.default)
//         loadedLanguages.push(lang)
//         return setI18nLanguage(lang)
//       })
//     } 
//     return Promise.resolve(setI18nLanguage(lang))
//   }
//   return Promise.resolve(lang)
// }

export default i18n;